module.exports = __webpack_public_path__ + "static/media/max-5th-birthday-cake.9ae664a8.jpg";